export const AnnouncementStorageKeys = {
    modal: 'tw-announcement-modal',
};

export const TW_ANNOUNCEMENT_URL = 'https://teamworks.com/blog/teamworks-acquires-telemetry-sports';
